import { Link } from 'react-router-dom';
import { ArrowLeft, Shield } from '../components/icons';

export function PrivacyPage() {
  return (
    <div className="min-h-screen freud-bg py-12 px-4">
      <div className="max-w-3xl mx-auto">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-chocolate-600 hover:text-sage-600 mb-8 transition-colors font-medium"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to Home
        </Link>

        <div className="freud-card-elevated p-8">
          <div className="flex items-center gap-3 mb-8">
            <div className="p-3 bg-sage-100 rounded-xl">
              <Shield className="w-6 h-6 text-sage-600" />
            </div>
            <h1 className="freud-heading-2xl text-chocolate-900">Privacy Policy</h1>
          </div>

          <div className="prose prose-chocolate max-w-none">
            <p className="freud-text-base text-chocolate-500 mb-6">
              Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
            </p>

            <h2 className="freud-heading-lg text-chocolate-900 mt-8 mb-4">1. Information We Collect</h2>
            <p className="freud-text-base text-chocolate-600 mb-4">
              We collect information you provide directly to us, including:
            </p>
            <ul className="list-disc pl-6 freud-text-base text-chocolate-600 space-y-2 mb-6">
              <li>Account information (name, email address)</li>
              <li>Assessment responses and results</li>
              <li>Communication preferences</li>
              <li>Any other information you choose to provide</li>
            </ul>

            <h2 className="freud-heading-lg text-chocolate-900 mt-8 mb-4">2. How We Use Your Information</h2>
            <p className="freud-text-base text-chocolate-600 mb-4">
              We use the information we collect to:
            </p>
            <ul className="list-disc pl-6 freud-text-base text-chocolate-600 space-y-2 mb-6">
              <li>Provide, maintain, and improve our services</li>
              <li>Process and complete your assessments</li>
              <li>Generate personalized insights and recommendations</li>
              <li>Communicate with you about our services</li>
              <li>Protect against fraudulent or illegal activity</li>
            </ul>

            <h2 className="freud-heading-lg text-chocolate-900 mt-8 mb-4">3. Information Sharing</h2>
            <p className="freud-text-base text-chocolate-600 mb-6">
              We do not sell, trade, or rent your personal information to third parties. We may share your information with:
            </p>
            <ul className="list-disc pl-6 freud-text-base text-chocolate-600 space-y-2 mb-6">
              <li>Your assigned coach or partner organization</li>
              <li>Service providers who assist in our operations</li>
              <li>When required by law or to protect our rights</li>
            </ul>

            <h2 className="freud-heading-lg text-chocolate-900 mt-8 mb-4">4. Data Security</h2>
            <p className="freud-text-base text-chocolate-600 mb-6">
              We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.
            </p>

            <h2 className="freud-heading-lg text-chocolate-900 mt-8 mb-4">5. Your Rights</h2>
            <p className="freud-text-base text-chocolate-600 mb-4">
              You have the right to:
            </p>
            <ul className="list-disc pl-6 freud-text-base text-chocolate-600 space-y-2 mb-6">
              <li>Access your personal information</li>
              <li>Correct inaccurate data</li>
              <li>Request deletion of your data</li>
              <li>Object to processing of your data</li>
              <li>Export your data in a portable format</li>
            </ul>

            <h2 className="freud-heading-lg text-chocolate-900 mt-8 mb-4">6. Cookies</h2>
            <p className="freud-text-base text-chocolate-600 mb-6">
              We use cookies and similar technologies to enhance your experience, analyze usage, and assist in our marketing efforts. You can control cookies through your browser settings.
            </p>

            <h2 className="freud-heading-lg text-chocolate-900 mt-8 mb-4">7. Contact Us</h2>
            <p className="freud-text-base text-chocolate-600 mb-6">
              If you have any questions about this Privacy Policy, please contact us at support@notify.nlpos.app.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
